import {
    RequestStatusE,
    RequestStatusKorE,
    RequestStatusT,
    ServiceTypeE,
    ServiceTypeKorE,
    ServiceTypeT,
    TargetServiceTypeE,
    TargetServiceTypeKorE,
    TargetServiceTypeT,
} from '@/types/points/point-keyword-types';

export const getRequestStatusKorName = (status: RequestStatusT) => {
    switch (status) {
        case RequestStatusE.REQUEST_READY:
            return RequestStatusKorE.요청대기;
        case RequestStatusE.REQUEST_CANCEL:
            return RequestStatusKorE.요청취소;
        case RequestStatusE.CONFIRM:
            return RequestStatusKorE.승인;
        case RequestStatusE.REJECT:
            return RequestStatusKorE.반려;
        case RequestStatusE.PROCESSING:
            return RequestStatusKorE.처리중;
        case RequestStatusE.FINISHED:
            return RequestStatusKorE.처리완료;
        default:
            return '';
    }
};

export const getServiceTypeKorName = (status: ServiceTypeT) => {
    switch (status) {
        case ServiceTypeE.IMMEDIATELY:
            return ServiceTypeKorE.즉시지급;
        case ServiceTypeE.RESERVE:
            return ServiceTypeKorE.예약지급;
        case ServiceTypeE.RETRIEVE:
            return ServiceTypeKorE.회수;
        default:
            return '';
    }
};

export const getTargetServiceTypeKorName = (status: TargetServiceTypeT) => {
    switch (status) {
        case TargetServiceTypeE.PROVIDE:
            return TargetServiceTypeKorE.지급;
        case TargetServiceTypeE.RETRIEVE:
            return TargetServiceTypeKorE.회수;
        default:
            return '';
    }
};
